import React from 'react';
import { T } from './traks';

/* returns the first argument that's not `undefined`. or returns `undefined`,
 * if all arguments are `undefined` */
function coalesce() {
	for (var i = 0; i < arguments.length; i++) {
		var arg = arguments[i];
		if (arg !== undefined) return arg;
	}
	return undefined;
}

function parse_date(dstr) {
	if (!dstr) return null;
	const xs = dstr.split("-");
	if (xs.length !== 3) return null;
	const yyyy = parseInt(xs[0], 10);
	const mm1 = parseInt(xs[1], 10);
	const dd = parseInt(xs[2], 10);
	if (yyyy === 0 && mm1 === 0 && dd === 0) return null;
	return new Date(yyyy, mm1-1, dd);
}

function check_date(dval) {
	if (dval instanceof Date) return dval;
	return parse_date(dval);
}

/* if n=3 and xs=[1,2,3,4,5,6,7,8], this will return [[1,2,3],[4,5,6],[7,8]] */
function segmentize(n, xs) {
	var segments = [];
	var segment = [];
	for (const x of xs) {
		segment.push(x);
		if (xs.length >= n) {
			segments.push(segment);
			segment = [];
		}
	}
	if (segment.length > 0) segments.push(segment);
	return segments;
}

function array2set(xs) {
	var set = {};
	for (var x of (xs||[])) set[x] = true;
	return set;
}

function setCommodityName(ticker, name) {
    if (ticker === 'CANE') {
        return <T>Sugar</T>
    } else if (ticker === 'CPER') {
        return <T>Copper</T>
    } else if (ticker === 'GLD') {
        return <T>Gold</T>
    } else if (ticker === 'IYM') {
        return <T>Aluminium</T>
    } else if (ticker === 'LIT') {
        return <T>Lithium</T>
    } else if (ticker === 'PALL') {
        return <T>Palladium</T>
    } else if (ticker === 'PPLT') {
        return <T>Platinum</T>
    } else if (ticker === 'SLV') {
        return <T>Silver</T>
    } else if (ticker === 'SLX') {
        return <T>Steel</T>
    } else if (ticker === 'UNG') {
        return <T>Natural Gas</T>
    } else if (ticker === 'URA') {
        return <T>Uranium</T>
    } else if (ticker === 'USO') {
        return <T>Oil</T>
    } else if (ticker === 'WEAT') {
        return <T>Wheat</T>
    } else if (ticker === 'NIKL') {
        return <T>Nickel</T>
    } else if (ticker === 'WOOD') {
        return <T>Timber</T>
    }

    return name;
}

function validatePremium(me) {
	if (me.TempSubscription === undefined) {
		me.TempSubscription = 'free';
	}
    if (me && (me.Subscription.includes('pro', 'enterprise') || me.TempSubscription.includes('pro', 'enterprise'))) {
        return true;
    }

    return false;
}

function dataPlaceholder(data, placeholder = '-') {
    if (!data || data === 0 || `${data}`.length === 0) {
        return placeholder;
    } else {
        return data;
    }
}

const formatWithSeparators = (num) => {
    const [integerPart, decimalPart] = num.toString().split('.');

    const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    return decimalPart ? `${formattedIntegerPart},${decimalPart}` : formattedIntegerPart;
};

export {
	coalesce,
	parse_date,
	check_date,
	segmentize,
	array2set,
    validatePremium,
    dataPlaceholder,
	formatWithSeparators,
    setCommodityName
};



// WEBPACK FOOTER //
// ./src/misc.js